export const SEEK_INTERVAL = 120;
export const DEFAULT_VOLUME = 0.8;
export const SOUND_FORMATS = ['mp3', 'ogg', 'wav', 'webm'];

export const soundStatus = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  FAILED: 'FAILED'
};
